import React from "react";

import "../assets/styles/generalTerms.css";

const TermsContent = () => {
  return (
    <>
      <div className="py-5">
        <p>
          <strong>Última atualização: 06 de outubro de 2026</strong>
        </p>
        <p>
          <strong>Bem-vindo à Puríssima.</strong> Este documento descreve os termos
          para uso do nosso site e para a contratação dos nossos serviços. Ao
          navegar pela plataforma, preencher a anamnese ou contratar nossos
          serviços, você declara que leu, compreendeu e concorda com os termos e
          condições descritos a seguir.
        </p>

        <p>
          A Puríssima Farmácia de Manipulação S.A. é uma pessoa jurídica de
          direito privado, inscrita no CNPJ 58.771.439/0001-06, com sede na
          cidade de Juiz de Fora, Estado de Minas Gerais, Rua Halfeld, 1156,
          Centro, CEP 36016-000, farmácia de manipulação regularmente licenciada,
          que atua sob responsabilidade técnica farmacêutica.
        </p>

        <p>
          <strong>O que você contrata na Puríssima é um serviço farmacêutico:</strong>{" "}
          avaliação de saúde, prescrição individual por profissional habilitada e
          manipulação de preparação magistral personalizada, destinada
          exclusivamente a você. Nenhuma preparação existe antes da sua avaliação
          e da prescrição correspondente.
        </p>
      </div>

      <article>
        <h3>1. Cadastro, elegibilidade e segurança da conta</h3>
        <p>
          Para acessar e contratar nossos serviços através do nosso site
          https://www.purissima.com ("Plataforma"), você deverá se cadastrar, a
          partir da criação de login e senha.
        </p>

        <p>
          Você é responsável por escolher uma senha segura. Você deve criar uma
          senha forte, com números, letras e outros caracteres. Tenha cuidado ao
          usar redes e computadores públicos ou de terceiros, cuja segurança
          seja desconhecida ou não seja razoável, e ao gravar senhas de forma
          automática em computadores e dispositivos móveis.
        </p>

        <p>
          Você é responsável por manter a confidencialidade de seus dados de
          login e será também o único responsável por todas as atividades que
          ocorrerem em sua conta ou por meio dela.
        </p>

        <p>
          Você concorda em comunicar a Puríssima, imediatamente, se suspeitar de
          qualquer utilização não autorizada de sua conta.
        </p>

        <p>
          A Puríssima não será responsável por quaisquer perdas e danos
          resultantes de acessos não autorizados, ou uso de sua conta em caso de
          descuido ou negligência na confidencialidade das informações de login.
          Igualmente, a Puríssima não se responsabilizará pela utilização de
          senhas vulneráveis, existência de vírus ou programas maliciosos em
          seus dispositivos.
        </p>

        <p>
          Ao se cadastrar, autenticar e usar a Plataforma, você declara e
          garante, assumindo total responsabilidade (inclusive cível e criminal)
          que:
        </p>
        <ol>
          <li>possui capacidade legal, de acordo com as leis brasileiras;</li>
          <li>
            todas as informações, pessoais ou não, enviadas por você são
            verdadeiras e exatas, bem como você possui autorização para
            compartilhá-las na Plataforma;
          </li>
          <li>
            atualizará seus dados pessoais sempre que necessário, especialmente
            os dados para contato;
          </li>
          <li>
            ao usar a Plataforma, você não viola qualquer lei, acordo com
            terceiros ou direito de terceiros;
          </li>
          <li>você não realizará engenharia reversa ou descompilará a Plataforma; e</li>
          <li>
            manterá sua regularidade perante todos e quaisquer órgãos,
            autoridades ou entidades a que esteja legalmente vinculado.
          </li>
        </ol>

        <p>
          A Puríssima se reserva o direito de impedir, a seu exclusivo critério
          e sem qualquer aviso prévio, novos cadastros, suspender ou cancelar os
          já efetuados, caso detecte qualquer anomalia que, em sua análise, seja
          revestida de gravidade ou demonstre tentativa deliberada de burlar as
          regras aqui descritas.
        </p>
      </article>

      <article>
        <h3>2. Como funciona o serviço</h3>
        <ol>
          <li>
            <strong>Anamnese individual –</strong> Você responde,
            individualmente, a perguntas sobre nutrição, sono, hábitos, rotina,
            uso de medicamentos, alergias e sintomas. Essas informações
            constituem a sua avaliação de saúde e ficam registradas no seu
            cadastro.
          </li>
          <li>
            <strong>Referência preliminar, sem natureza de prescrição –</strong>{" "}
            A partir das suas respostas, a ferramenta digital pode organizar e
            apresentar uma referência preliminar, de caráter exclusivamente
            informativo. Essa referência não é prescrição, não tem valor
            clínico autônomo, não vincula a profissional e não autoriza, por
            si, qualquer manipulação.
          </li>
          <li>
            <strong>Avaliação e prescrição por profissional habilitada –</strong>{" "}
            Sua anamnese é recebida e avaliada individualmente por profissional
            de saúde habilitada e inscrita em conselho profissional, que
            analisa o seu caso concreto e decide a formulação, podendo manter,
            ajustar, incluir ou remover ativos, ou ainda não aprovar a fórmula.
            A decisão sobre a formulação é sempre da profissional, e não do
            sistema. Concluída a avaliação, é emitida a sua prescrição
            individual, assinada, com composição, forma farmacêutica,
            posologia e modo de usar.
          </li>
          <li>
            <strong>Avaliação farmacêutica e conferência técnica –</strong> Antes
            de qualquer manipulação, a prescrição é submetida à avaliação
            farmacêutica, quanto a concentração, viabilidade, compatibilidade e
            dose, e à conferência da responsável técnica da farmácia, que
            autoriza a liberação ao laboratório.
          </li>
          <li>
            <strong>Manipulação sob prescrição, sem estoque –</strong> Não
            trabalhamos com estoque de produto acabado nem com pré-misturas.
            Cada preparação é manipulada sob demanda, exclusivamente após a
            emissão da sua prescrição individual e a conferência técnica, e é
            rotulada com o seu nome e com a identificação da prescritora.
          </li>
          <li>
            <strong>Entrega –</strong> Enviamos para todo o Brasil. Os prazos
            variam conforme a região.
          </li>
          <li>
            <strong>Triagem de segurança –</strong> Determinados perfis
            clínicos não são atendidos pela Puríssima, hipótese em que
            orientamos o encaminhamento a profissional médico. Nossa avaliação
            tem finalidade nutricional e não constitui diagnóstico.
          </li>
          <li>
            <strong>Importante –</strong> As preparações da Puríssima não
            substituem diagnóstico, tratamento ou acompanhamento médico. Nenhum
            medicamento em uso deve ser interrompido sem orientação do seu
            médico. Se você possui condições de saúde específicas, mantenha
            suas consultas em dia.
          </li>
        </ol>
      </article>

      <article>
        <h3>3. Personalização e composição da fórmula</h3>
        <h4 className="text-uppercase">
          <strong>Composição do valor</strong>
        </h4>
        <p>
          O valor reflete o conjunto do serviço clínico e operacional que
          sustenta a entrega com padrão e segurança. Esse valor advém da
          avaliação da anamnese, da avaliação e prescrição por profissional
          habilitada, da avaliação farmacêutica e da conferência técnica, da
          responsabilidade técnica e sanitária do processo, da rastreabilidade
          de cada preparação, das horas de manipulação e etapas de conferência,
          da equipe clínica e de qualidade envolvida, dos sistemas, da
          logística e do suporte ao cliente.
        </p>
        <p>
          O valor não é calculado apenas como soma de matérias-primas e, por
          isso, não acompanha de forma linear a entrada ou a saída de um único
          ingrediente.
        </p>
        <h4 className="text-uppercase">
          <strong>Ajustes de formulação</strong>
        </h4>
        <p>
          Em caso de indisponibilidade, descontinuidade ou instabilidade
          técnica de qualquer insumo, a profissional prescritora poderá
          promover ajuste pontual e temporário na formulação, mediante nova
          prescrição individual, sempre preservando a segurança e a coerência
          clínica do seu protocolo.
        </p>
        <p>
          Tais ajustes visam manter a segurança e a continuidade do seu
          cronograma de uso diante de fatores externos de mercado, e não geram
          direito a compensações financeiras, abatimentos ou reembolsos, uma
          vez que o serviço clínico e operacional da personalização permanece
          integralmente prestado.
        </p>
        <h4 className="text-uppercase">
          <strong>Alteração de sabores</strong>
        </h4>
        <p>
          Você pode alterar os sabores <strong>até 5 dias após receber cada pedido.</strong>
        </p>
        <h4 className="text-uppercase">
          <strong>Acompanhamento</strong>
        </h4>
        <p>
          Independentemente da modalidade contratada,{" "}
          <strong>a cada 3 meses você será convidado a responder uma nova anamnese</strong>.
          Essa atualização permite que a sua prescrição acompanhe as
          transformações do seu corpo, da sua rotina e do seu momento de vida,
          e que sejam captadas mudanças relevantes, como gestação, novo
          diagnóstico médico ou início de uso de medicamento.
        </p>
      </article>

      <article>
        <h3>4. Modalidades de contratação</h3>
        <p>
          Cada remessa é precedida de prescrição individual válida, emitida por
          profissional habilitada, e somente é manipulada após essa prescrição
          e a conferência técnica. As modalidades abaixo dizem respeito
          exclusivamente à forma de contratação e de pagamento do serviço.
        </p>
        <h4 className="text-uppercase">
          <strong>Pedido Único</strong>
        </h4>
        <ul>
          <li>Pagamento único via cartão ou Pix.</li>
          <li>Sem renovação automática e sem cobranças futuras.</li>
        </ul>
        <h4 className="text-uppercase">
          <strong>Assinatura Trimestral</strong>
        </h4>
        <ul>
          <li>
            Trata-se de plano de assinatura com duração de 3 (três) meses, com
            envio mensal (3 remessas por período).
          </li>
          <li>
            10% de desconto no plano, condicionado ao cumprimento do período de
            3 meses.
          </li>
          <li>
            O valor correspondente ao período é cobrado no cartão de crédito no
            ato da contratação.
          </li>
          <li>
            <strong>Renovação automática:</strong> ao final de cada período de
            3 meses, o plano é renovado automaticamente por novo período de 3
            meses, caso você não cancele a assinatura antes da data de
            renovação. A cada renovação é realizada nova cobrança automática no
            cartão cadastrado, referente ao novo período.
          </li>
        </ul>
        <h4 className="text-uppercase">
          <strong>Assinatura Anual</strong>
        </h4>
        <ul>
          <li>
            Trata-se de plano de assinatura com duração de 12 (doze) meses, com
            envio mensal (12 remessas por período).
          </li>
          <li>
            20% de desconto no plano, condicionado ao cumprimento do período de
            12 meses — a maior economia.
          </li>
          <li>
            O valor correspondente ao período é cobrado no cartão de crédito no
            ato da contratação.
          </li>
          <li>
            <strong>Renovação automática:</strong> ao final de cada período de
            12 meses, o plano é renovado automaticamente por novo período de 12
            meses, caso você não cancele a assinatura antes da data de
            renovação. A cada renovação é realizada nova cobrança automática no
            cartão cadastrado, referente ao novo período.
          </li>
        </ul>
        <h4 className="text-uppercase">
          <strong>Como evitar a renovação</strong>
        </h4>
        <ul>
          <li>
            Para que o plano não seja renovado, basta cancelar a assinatura após
            receber o último pedido do período contratado e antes da data da
            nova cobrança, pelos canais indicados na Seção 15.
          </li>
          <li>
            Não havendo cancelamento até essa data, o plano é renovado e a
            cobrança do novo período é realizada.
          </li>
          <li>
            Você será avisado por e-mail com alguns dias de antecedência da data
            de renovação.
          </li>
        </ul>
      </article>

      <article>
        <h3>5. Cancelamento</h3>
        <ul>
          <li>
            <strong>Efeito do cancelamento –</strong> Interrompe as próximas
            cobranças e as remessas que ainda não entraram em produção, e impede
            a renovação automática do plano.
          </li>
          <li>
            <strong>Produção em andamento –</strong> Preparações que já
            iniciaram a manipulação ou foram enviadas não podem ser canceladas,
            por se tratar de preparação magistral individualizada.
          </li>
          <li>
            <strong>Pausa –</strong> A qualquer momento você pode pausar a
            assinatura em vez de cancelar, adiando as próximas remessas e
            cobranças, sem custo.
          </li>
          <li>
            <strong>
              Assinaturas Trimestral e Anual (cancelamento durante o período
              contratado) –
            </strong>{" "}
            O desconto do plano (10% no Trimestral, 20% no Anual) é concedido
            porque o ciclo inclui todas as remessas do período, pago
            antecipadamente. Se você cancelar antes de concluir o período
            contratado, as remessas ainda não produzidas são estornadas pelo
            valor efetivamente pago, retendo-se multa de 20% sobre esse valor a
            estornar, a título de multa pela quebra do compromisso de
            fidelidade, sendo o saldo de 80% devolvido ao assinante. Remessas
            já recebidas, em produção ou confirmadas para envio não são
            estornadas.
          </li>
          <li>
            <strong>Após o período contratado –</strong> Tendo recebido todos os
            pedidos do período contratado, você pode solicitar o cancelamento
            antes da data de renovação e nova cobrança, sem multa.
          </li>
          <li>
            <strong>Cancelamento feito depois da renovação –</strong> Gera o
            estorno das remessas ainda não produzidas do novo período, com
            retenção de multa de 20%.
          </li>
        </ul>
      </article>

      <article>
        <h3>6. Trocas e reembolsos</h3>
        <p>
          As preparações da Puríssima são magistrais, personalizadas e
          manipuladas sob demanda, elaboradas exclusivamente a partir da
          anamnese e da prescrição individual de cada paciente, e rotuladas
          nominalmente. Por essa razão, não se aplica o direito de
          arrependimento previsto no art. 49 do Código de Defesa do
          Consumidor, uma vez que a preparação não pode ser reaproveitada,
          redirecionada a outra pessoa ou revendida.
        </p>
        <p>
          Erro de envio, avaria ou falha nossa? Cuidaremos da substituição ou
          reembolso conforme nossa Política de Cancelamentos, Trocas e
          Reembolsos.
        </p>
      </article>

      <article>
        <h3>7. Seus dados e privacidade</h3>
        <p>
          Coletamos apenas os dados necessários para a sua avaliação, para a
          prescrição, para a manipulação, para a emissão de nota fiscal e para
          a entrega.
        </p>
        <p>
          Informações de saúde são tratadas como dados sensíveis conforme a
          LGPD, armazenadas com criptografia e nunca compartilhadas para fins de
          marketing sem o seu consentimento.
        </p>
        <p>
          Os registros da sua anamnese, da sua prescrição e da respectiva
          ordem de manipulação são mantidos pela farmácia, para fins de
          rastreabilidade e de atendimento às exigências sanitárias
          aplicáveis.
        </p>
        <p>Detalhes completos estão na nossa Política de Privacidade.</p>
      </article>

      <article>
        <h3>8. Propriedade intelectual</h3>
        <p>
          Todos os conteúdos da Plataforma, tais como textos, gráficos,
          imagens, fotos, ilustrações, marcas, denominação social, logotipos,
          informações, código-fonte, layouts, nomes de domínio, software,
          know-how e demais materiais, são de propriedade da Puríssima ou
          foram licenciados a ela, e são protegidos por direitos de
          propriedade intelectual.
        </p>
        <p>
          O uso da plataforma não concede a você qualquer direito sobre esses
          conteúdos.
        </p>
      </article>

      <article>
        <h3>9. Limitação de responsabilidade</h3>
        <p>
          A Puríssima responde por danos diretos devidamente comprovados, até o
          limite do valor pago pelo usuário.
        </p>
        <p>
          Cada organismo reage de forma específica e, por isso, não é possível
          prever ou garantir resultados.
        </p>
        <p>
          O efeito da preparação poderá variar de acordo com os hábitos de
          vida de cada pessoa, tais como uso de álcool, tabagismo, uso de
          medicamentos, alimentação, atividades físicas e variações de peso.
        </p>
        <p>
          A Puríssima não pode garantir resultado específico, pois cada pessoa
          possui características distintas. Nossa responsabilidade não se
          estende a efeitos adversos decorrentes de uso incorreto, de
          interrupção por conta própria ou de combinações indevidas com outros
          produtos, nem a consequências associadas a informações incompletas
          ou imprecisas fornecidas na anamnese.
        </p>
      </article>

      <article>
        <h3>10. Compromissos do usuário</h3>
        <p>
          Ao utilizar os serviços da Puríssima, você se compromete a fornecer
          informações verdadeiras e completas, especialmente quanto a
          condições de saúde, alergias e uso de medicamentos, e a respeitar as
          diretrizes previstas nestes Termos.
        </p>
        <p>
          A veracidade dessas informações é essencial para a segurança da
          avaliação e da prescrição.
        </p>
        <p>
          O uso indevido, incluindo inserção de dados falsos, tentativas de
          fraude, violação de direitos ou interferência na segurança do site,
          resultará em encerramento da conta, e a Puríssima poderá tomar as
          medidas legais cabíveis para reparação dos prejuízos.
        </p>
      </article>

      <article>
        <h3>11. Alterações nestes Termos</h3>
        <p>
          Podemos atualizar estes Termos a qualquer momento. As alterações serão
          publicadas nesta página com a respectiva data de atualização.
        </p>
        <p>
          O uso continuado da plataforma após mudanças implica aceitação dos
          novos termos.
        </p>
      </article>

      <article>
        <h3>12. Disponibilidade da plataforma</h3>
        <p>
          Trabalhamos para manter a plataforma disponível e as informações
          atualizadas, mas não garantimos funcionamento ininterrupto.
        </p>
        <p>
          Reservamo-nos o direito de corrigir erros de preço, descrição ou
          disponibilidade, e de cancelar pedidos afetados por informações
          incorretas.
        </p>
      </article>

      <article>
        <h3>13. Vigência</h3>
        <p>
          Estes Termos permanecem válidos enquanto você utilizar nossos
          serviços. Você pode encerrá-los a qualquer momento deixando de usar a
          plataforma.
        </p>
        <p>Podemos encerrar seu acesso se houver violação destes Termos.</p>
      </article>

      <article>
        <h3>14. Lei aplicável e foro</h3>
        <p>
          Estes Termos são regidos pelas leis brasileiras. Fica eleito o foro da
          Comarca de Juiz de Fora, MG, para dirimir quaisquer controvérsias.
        </p>
      </article>

      <article>
        <h3>15. Contato</h3>
        <p>Dúvidas, solicitações ou reclamações:</p>
        <p>
          <strong>Site:</strong> chat online
        </p>
        <p>
          <strong>E-mail:</strong> contato@purissima.com
        </p>
        <p>
          <strong>WhatsApp:</strong> 11 5283-6305
        </p>
      </article>

      <article>
        <h3>16. Disposições gerais</h3>
        <ul>
          <li>
            <strong>Veracidade –</strong> Você é o único responsável pela
            veracidade das informações fornecidas, incluindo a anamnese.
          </li>
          <li>
            <strong>Nulidade parcial –</strong> Se alguma disposição for
            considerada inválida ou inexequível, as demais permanecem em
            vigor.
          </li>
          <li>
            <strong>Acordo integral –</strong> Estes Termos, junto com nossas
            políticas publicadas, constituem o acordo completo entre você e a
            Puríssima.
          </li>
          <li>
            <strong>Tolerância –</strong> A tolerância quanto a descumprimentos
            pontuais não implica renúncia de direitos.
          </li>
        </ul>
        <p>Obrigado por escolher a Puríssima.</p>
      </article>
    </>
  );
};

export default TermsContent;
